var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.359,
    height: 9.108,
    viewBox: "0 0 13.359 9.108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-remove-red-eye",
    "data-name": "Icon material-remove-red-eye",
    d: "M8.179,6.75A7.182,7.182,0,0,0,1.5,11.3a7.175,7.175,0,0,0,13.359,0A7.182,7.182,0,0,0,8.179,6.75Zm0,7.59A3.036,3.036,0,1,1,11.216,11.3,3.037,3.037,0,0,1,8.179,14.34Zm0-4.858A1.822,1.822,0,1,0,10,11.3,1.819,1.819,0,0,0,8.179,9.483Z",
    transform: "translate(-1.5 -6.75)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.b6104df0c639f8e80615e5930de99835.svg";
export { ForwardRef as ReactComponent };